import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=de829e60&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=de829e60&prod&lang=scss&scoped=true"
import style1 from "./Main.vue?vue&type=style&index=1&id=de829e60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de829e60",
  null
  
)

export default component.exports